import {
  DashboardOutlined,
  AccountBookOutlined,
  LogoutOutlined,
  SettingOutlined,
  GroupOutlined,
  EditTwoTone,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
export const sidebarList = [
  {
    key: "/",
    icon: <DashboardOutlined />,
    label: <Link to="">Dashboard</Link>,
  },
  {
    key: "/inventory",
    icon: <AccountBookOutlined />,
    label: "Inventory",
    children: [
      {
        key: "/inventory/opening-inventory",
        icon: <EditTwoTone />,
        label: <Link to="inventory/opening-inventory">Opening Inventory</Link>,
      },
      {
        key: "/inventory/purchase-order",
        icon: <EditTwoTone />,
        label: <Link to="inventory/purchase-order">Purchase Order</Link>,
      },
      {
        key: "/inventory/grn",
        icon: <EditTwoTone />,
        label: <Link to="inventory/grn">GRN</Link>,
      },
      {
        key: "/inventory/production",
        icon: <EditTwoTone />,
        label: <Link to="inventory/production">Production</Link>,
      },
      {
        key: "/inventory/issuance",
        icon: <EditTwoTone />,
        label: <Link to="inventory/issuance">Issuance</Link>,
      },
      {
        key: "/inventory/customer-sale-invoice",
        icon: <EditTwoTone />,
        label: (
          <Link to="inventory/customer-sale-invoice">
            Customer Sale Invoice
          </Link>
        ),
      },
      {
        key: "/inventory/adjustment",
        icon: <EditTwoTone />,
        label: <Link to="inventory/adjustment">Adjustment</Link>,
      },
      {
        key: "/inventory/wastage",
        icon: <EditTwoTone />,
        label: <Link to="inventory/wastage">Wastage</Link>,
      },
      {
        key: "/inventory/physical-stock",
        icon: <EditTwoTone />,
        label: <Link to="inventory/physical-stock">Physical Stock</Link>,
      },
      {
        key: "/inventory/issuance-return",
        icon: <EditTwoTone />,
        label: <Link to="inventory/issuance-return">Issuance Return</Link>,
      },
      {
        key: "/inventory/invoice",
        icon: <EditTwoTone />,
        label: <Link to="inventory/invoice">Invoice</Link>,
      },
      {
        key: "/inventory/grn-return",
        icon: <EditTwoTone />,
        label: <Link to="inventory/grn-return">GRN Return</Link>,
      },
      {
        key: "/inventory/demand",
        icon: <EditTwoTone />,
        label: <Link to="inventory/demand">Demand</Link>,
      },
    ],
  },
  {
    key: "/setup",
    icon: <GroupOutlined />,
    label: "Setup",
    children: [
      {
        key: "/setup/branch",
        icon: <EditTwoTone />,
        label: <Link to="setup/branch">Add Branch</Link>,
      },
      {
        key: "/setup/category",
        icon: <EditTwoTone />,
        label: <Link to="setup/category">Add Category</Link>,
      },
      {
        key: "/setup/department",
        icon: <EditTwoTone />,
        label: <Link to="setup/department">Add Department</Link>,
      },
      {
        key: "/setup/item",
        icon: <EditTwoTone />,
        label: <Link to="setup/item">Add Item</Link>,
      },
      {
        key: "/setup/unit",
        icon: <EditTwoTone />,
        label: <Link to="setup/unit">Add Unit</Link>,
      },
      {
        key: "/setup/subcategory",
        icon: <EditTwoTone />,
        label: <Link to="setup/subcategory">Add Sub-Category</Link>,
      },
      {
        key: "/setup/supplier",
        icon: <EditTwoTone />,
        label: <Link to="setup/supplier">Add Supplier</Link>,
      },
      {
        key: "/setup/recipe",
        icon: <EditTwoTone />,
        label: <Link to="setup/recipe">Add Recipe</Link>,
      },
      {
        key: "/setup/user-inventory-role",
        icon: <EditTwoTone />,
        label: <Link to="setup/user-inventory-role">Add User Inventory Role</Link>,
      },
    ],
  },
  {
    key: "/setting",
    icon: <SettingOutlined />,
    label: <Link to="setting">Setting</Link>,
  },

];



export const  OPTIONS = [{value:'one',label:'One'},{value:'two',label:'Two'},{value:'three',label:'Three'}]


export const dummyQuotationData = [
  {
    BranchName: "North Branch",
    Department: "Sales",
    DemandNumber: "DN001",
    DemandDate: "2024-09-01",
    IsSubmit: true,
    items: [
      {
        ItemCode: "IC001",
        CategoryName: "Electronics",
        SubCategoryName: "Mobile Phones",
        ItemName: "iPhone 14",
        IssuanceUnit: "Units",
        Quantity: 10,
      },
      {
        ItemCode: "IC002",
        CategoryName: "Electronics",
        SubCategoryName: "Laptops",
        ItemName: "MacBook Pro",
        IssuanceUnit: "Units",
        Quantity: 5,
      },
    ],
  },
  {
    BranchName: "South Branch",
    Department: "Marketing",
    DemandNumber: "DN002",
    DemandDate: "2024-09-02",
    IsSubmit: false,
    items: [
      {
        ItemCode: "IC003",
        CategoryName: "Stationery",
        SubCategoryName: "Pens",
        ItemName: "Ballpoint Pen",
        IssuanceUnit: "Boxes",
        Quantity: 20,
      },
    ],
  },
  {
    BranchName: "East Branch",
    Department: "HR",
    DemandNumber: "DN003",
    DemandDate: "2024-09-03",
    IsSubmit: true,
    items: [
      {
        ItemCode: "IC004",
        CategoryName: "Office Supplies",
        SubCategoryName: "Notebooks",
        ItemName: "Spiral Notebook",
        IssuanceUnit: "Packs",
        Quantity: 15,
      },
      {
        ItemCode: "IC005",
        CategoryName: "Office Supplies",
        SubCategoryName: "Folders",
        ItemName: "File Folder",
        IssuanceUnit: "Units",
        Quantity: 30,
      },
    ],
  },
  {
    BranchName: "West Branch",
    Department: "IT",
    DemandNumber: "DN004",
    DemandDate: "2024-09-04",
    IsSubmit: false,
    items: [],
  },
  {
    BranchName: "Central Branch",
    Department: "Finance",
    DemandNumber: "DN005",
    DemandDate: "2024-09-05",
    IsSubmit: true,
    items: [
      {
        ItemCode: "IC006",
        CategoryName: "Finance Tools",
        SubCategoryName: "Calculators",
        ItemName: "Scientific Calculator",
        IssuanceUnit: "Units",
        Quantity: 12,
      },
    ],
  },
];

export const dummybranches = [
  {
    Id: 1,
    CompanyId: 1,
    Name: "ygen upd",
    ShortName: "3030",
    UniqueId: "0608a638-cfd6-4ec0-a73c-457e6455f0a9",
    HeadOffice: true,
    Enabled: false,
    Deleted: false,
    BranchId: 1,
  },
  {
    Id: 3,
    CompanyId: 1,
    Name: "DHA",
    ShortName: "654",
    UniqueId: "803638bf-24fb-4dfc-b208-c280426fcc42",
    HeadOffice: false,
    Enabled: true,
    Deleted: false,
    BranchId: 3,
  },
  {
    Id: 4,
    CompanyId: 1,
    Name: "New Branch",
    ShortName: "555",
    UniqueId: "74c46753-661b-4908-a16d-73e0f21ad8d3",
    HeadOffice: true,
    Enabled: true,
    Deleted: false,
    BranchId: 4,
  },
  {
    Id: 5,
    CompanyId: 1,
    Name: "samad checking",
    ShortName: "276",
    UniqueId: "a175488f-ea8a-4348-8aef-6ae446754b99",
    HeadOffice: true,
    Enabled: false,
    Deleted: false,
    BranchId: 5,
  },
];

export const dummydepartments = [
  {
    Id: 1,
    BranchId: 1,
    Name: "STORE",
    ShortName: "4646",
    Enabled: true,
    Deleted: false,
    DepartmentId: 1,
  },
  {
    Id: 2,
    BranchId: 43,
    Name: "dept 01",
    ShortName: "111",
    Enabled: true,
    Deleted: false,
    DepartmentId: 2,
  },
  {
    Id: 3,
    BranchId: 43,
    Name: "dept 02",
    ShortName: "320",
    Enabled: true,
    Deleted: false,
    DepartmentId: 3,
  },
  {
    Id: 10,
    BranchId: 43,
    Name: "asf",
    ShortName: "3434asf",
    Enabled: true,
    Deleted: false,
    DepartmentId: 10,
  },
  {
    Id: 11,
    BranchId: 43,
    Name: "new right now",
    ShortName: "0344",
    Enabled: true,
    Deleted: false,
    DepartmentId: 11,
  },
  {
    Id: 14,
    BranchId: 3,
    Name: "newygen branch",
    ShortName: "646`",
    Enabled: true,
    Deleted: false,
    DepartmentId: 14,
  },
  {
    Id: 15,
    BranchId: 1,
    Name: "freshdepartment",
    ShortName: "23",
    Enabled: true,
    Deleted: false,
    DepartmentId: 15,
  },
  {
    Id: 16,
    BranchId: 1,
    Name: "fresh department",
    ShortName: "45",
    Enabled: true,
    Deleted: false,
    DepartmentId: 16,
  },
  {
    Id: 17,
    BranchId: 1,
    Name: "sdfadsf",
    ShortName: "23",
    Enabled: true,
    Deleted: false,
    DepartmentId: 17,
  },
  {
    Id: 18,
    BranchId: 5,
    Name: "samachecking",
    ShortName: "23",
    Enabled: true,
    Deleted: false,
    DepartmentId: 18,
  },
];

export const items = [
  {
    ItemCode: "IC001",
    CategoryName: "Electronics",
    SubCategoryName: "Mobile Phones",
    ItemName: "iPhone 14",
    IssuanceUnit: "Units",
    Quantity: 10,
  },
  {
    ItemCode: "IC002",
    CategoryName: "Electronics",
    SubCategoryName: "Laptops",
    ItemName: "MacBook Pro",
    IssuanceUnit: "Units",
    Quantity: 5,
  },
  {
    ItemCode: "IC003",
    CategoryName: "Stationery",
    SubCategoryName: "Pens",
    ItemName: "Ballpoint Pen",
    IssuanceUnit: "Boxes",
    Quantity: 20,
  },
  {
    ItemCode: "IC004",
    CategoryName: "Office Supplies",
    SubCategoryName: "Notebooks",
    ItemName: "Spiral Notebook",
    IssuanceUnit: "Packs",
    Quantity: 15,
  },
  {
    ItemCode: "IC005",
    CategoryName: "Office Supplies",
    SubCategoryName: "Folders",
    ItemName: "File Folder",
    IssuanceUnit: "Units",
    Quantity: 30,
  },
]